import { useState } from 'react';
import { Alert } from 'react-bootstrap';

const BETA_URL = 'https://beta.msg.nogi46.me/';

const BetaSiteBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <Alert
      variant="info"
      dismissible
      onClose={() => setDismissed(true)}
      className="mb-3 mt-2 py-2"
      style={{ borderRadius: '8px', border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
    >
      <div className="d-flex align-items-center">
        <i className="bi bi-stars me-2" style={{ fontSize: '1.25rem' }}></i>
        <span>
          新版網站 Beta 版已上線！
          <a
            href={BETA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ms-2 fw-bold"
          >
            立即體驗
          </a>
        </span>
      </div>
    </Alert>
  );
};

export default BetaSiteBanner;
